import { Link } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800/80 bg-ink-950" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-zinc-800 bg-ink-900">
                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" aria-hidden="true">
                  <path d="M5 13.5 10 18 19 6" stroke="#CCFF00" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              <span className="font-display text-lg font-bold tracking-tight text-zinc-100">AVIROVA</span>
            </div>
            <p className="mt-4 max-w-sm font-display text-2xl font-medium leading-snug tracking-tight text-zinc-300">
              {COMPANY.tagline}
            </p>
            <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">
              Sample case studies on this site are illustrative demonstrations, not client work.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-7">
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">Navigation</p>
              <ul className="mt-5 space-y-3">
                {[
                  ["Home", "/"],
                  ["Services", "/services"],
                  ["About", "/about"],
                  ["Case Studies", "/case-studies"],
                  ["Contact", "/contact"],
                ].map(([label, to]) => (
                  <li key={to}>
                    <Link
                      to={to}
                      data-testid={`footer-nav-${label.toLowerCase().replace(/\s/g, "-")}`}
                      className="text-sm text-zinc-400 transition-colors duration-300 hover:text-volt"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">Company</p>
              <ul className="mt-5 space-y-3">
                <li>
                  <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-sm text-zinc-400 transition-colors duration-300 hover:text-volt">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" data-testid="footer-terms-link" className="text-sm text-zinc-400 transition-colors duration-300 hover:text-volt">
                    Terms &amp; Conditions
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">Contact</p>
              <ul className="mt-5 space-y-3">
                <li>
                  <a
                    href={`mailto:${COMPANY.email}`}
                    data-testid="footer-email-link"
                    className="flex items-center gap-2 text-sm text-zinc-400 transition-colors duration-300 hover:text-volt"
                  >
                    <Mail className="h-3.5 w-3.5" /> {COMPANY.email}
                  </a>
                </li>
                <li>
                  <span data-testid="footer-linkedin-link" className="flex items-center gap-2 text-sm text-zinc-400">
                    <Linkedin className="h-3.5 w-3.5" /> {COMPANY.linkedin}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-zinc-800/80 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">
            © 2026 {COMPANY.name}. All rights reserved.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">
            Built for teams that ship with confidence
          </p>
        </div>
      </div>
    </footer>
  );
}
